import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { ColorBoxContent } from '../../../common/ui/colorBox'
import { DropdownItem, DropdownList } from '../../../common/ui/dropdowns'

function BundleMgmtCell({ bundle, bundleUsage, team, setTeam, teamOptions }) {
  const navigate = useNavigate()
  const [menuAnchor, setMenuAnchor] = useState(null)
  const open = Boolean(menuAnchor)
  const handleClose = () => {
    setMenuAnchor(null)
  }
  return (
    <ColorBoxContent>
      <Box display='flex' flexDirection='column'>
        <Box display='flex' flexDirection='row'>
          {/* Switch Team List */}
          <Box
            display='flex'
            flexDirection='row'
            justifyContent='space-between'
            alignItems='center'
          >
            <div id='dashboard__teamname'>
              <Typography>
                <strong>{team}</strong>
              </Typography>
              {/* <DropdownButton onClick={handleClick}>
                <ChevronDownIcon />
              </DropdownButton> */}

              <DropdownList
                anchorEl={menuAnchor}
                open={open}
                onClose={handleClose}
              >
                {teamOptions.map((teamName) => (
                  <DropdownItem
                    key={teamName}
                    onClick={() => {
                      handleClose()
                      setTeam(teamName)
                    }}
                  >
                    {teamName}
                  </DropdownItem>
                ))}
              </DropdownList>
            </div>
          </Box>
        </Box>
        <Box display='flex' flexDirection='row' justifyContent='space-between'>
          <Box>
            <Typography>
              {bundle.type}
              <br />
              <b>SGD${bundle.price.toFixed(2)}/mo</b>
              <br />
              <i>{bundleUsage.status}</i>
            </Typography>
          </Box>
          <Box
            display='flex'
            flexDirection='row'
            justifyContent='flex-end'
            alignItems='flex-end'
          >
            {/* increase the width of Purchase new add on button from 40% to 100% */}
            <Box sx={{ height: '40px' }}>
              <Button
                sx={{ marginRight: '16px' }}
                variant='contained'
                onClick={() => navigate('/app/order/new')}
              >
                Buy New SIMs
              </Button>
            </Box>
            {/* TODO: Plan bundle management page
            <Button variant='primary' onClick={() => navigate('manage-bundle')}>
              Manage Plan Bundle
            </Button>
            */}
          </Box>
        </Box>
      </Box>
    </ColorBoxContent>
  )
}

BundleMgmtCell.propTypes = {
  bundle: PropTypes.object,
  bundleUsage: PropTypes.object,
  team: PropTypes.string,
  setTeam: PropTypes.func,
  teamOptions: PropTypes.array
}

export default BundleMgmtCell
